import ClientService from "@/services/ClientService.js"

export const namespaced = true
export const state = {
  clients: [],
  client: {},
  client_edit: {},
  location_edit: {}
}

export const mutations = {
  SET_CLIENTS(state, clients) {
    state.clients = clients
  },
  SET_CLIENT_EDIT(state, client_edit) {
    state.client_edit = client_edit
  },
  SET_LOCATION_EDIT(state, location_edit) {
    state.location_edit = location_edit
  },
  ADD_CLIENT(state, client) {
    state.clients.push(client)
  }
}

export const getters = {
  getClientById: state => id => {
    //console.log(state)
    return state.clients.find(client => client.ClientID === id)
  },
  ClientCount: state => {
    return state.clients.length
  },
  LocationCount: state => {
    return state.client_edit.Locations.length
  }
}

export const actions = {
  fetchClients({ commit }) {
    return ClientService.get_Clients()
      .then(response => {
        //Note: use rootstate to pass in global state to access
        //data from other modules (this comes from store.js)
        //console.log('from another module: ' + rootState.user.user.name)
        //console.log('total events: ' + response.headers['x-total-count'])
        commit("SET_CLIENTS", response.data)
        //commit("SET_EVENTCOUNT", response.headers["x-total-count"])
      })
      .catch(error => {
        console.log(error.message)
        // const notification = {
        //   type: "error",
        //   message: "there was an error fetching events: " + error.message
        // }
        // dispatch("notification/add", notification, { root: true })
      })
  },
  createClient({ commit, dispatch }, client) {
    commit("ADD_CLIENT", client)
  },
  loadClientEdit({ commit, getters, dispatch }, value) {
    //This is good, use getters first then call api
    // changing it to test progress bars
    console.log(value)
    var client = getters.getClientById(value)
    if (client) {
      console.log("FROM GETTER")
      console.log(client)
      commit("SET_CLIENT_EDIT", client)
    } else {
      console.log("calling API")
      /* return EventService.getEvent(value)
        .then(response => {
          commit("SET_EVENT", response.data)
        })
        .catch(error => {
          const notification = {
            type: "error",
            message: "there was an error fetching event: " + error.message
          }
          dispatch("notification/add", notification, { root: true })
        })
      //}*/
    }
  },
  loadLocationEdit({ commit, getters, dispatch }, value) {
    var location = value
    commit("SET_LOCATION_EDIT", location)
  }
}
